var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactPannellum from 'react-pannellum';
import uniqueId from 'lodash/uniqueId';
import React, { useContext } from 'react';
import { Optional } from '@honda-canada/design-system-react';
import Context from './service/Context';
import useInterior360State from './hooks/useInterior360State';
import useThreeSixtyState from './hooks/useThreeSixtyState';
import ThreeSixtyContainer, { ThreeSixtyAnimatedLoader } from './ThreeSixtyContainer';
import { Image, PannellumContainer } from './ExteriorView.styles';
var Interior360View = function (_a) {
    var assetColor = _a.assetColor, images = _a.images, assetType = _a.assetType, gtmVehicleData = _a.gtmVehicleData;
    var is360Mode = useContext(Context).is360Mode;
    var _b = useThreeSixtyState({
        accessoriesWithOverlayImages: undefined,
        images: images,
        assetColor: assetColor,
        is360Mode: is360Mode,
    }), deviceImages = _b.deviceImages, iconSize = _b.iconSize, imageLoaded = _b.imageLoaded, isImagesLoading = _b.isImagesLoading, imgRef = _b.imgRef, getPanoramicImages = _b.getPanoramicImages, onImageLoaded = _b.onImageLoaded, imgHeight = _b.imgHeight;
    var _c = useInterior360State({
        getPanoramicImages: getPanoramicImages,
        assetColor: assetColor,
        deviceImages: deviceImages,
        assetType: assetType,
    }), url = _c.url, alt = _c.alt, currentImageUrl = _c.currentImageUrl, panoramicImageLoaded = _c.panoramicImageLoaded, setPanoramicImageLoaded = _c.setPanoramicImageLoaded, defaultConfig = _c.defaultConfig, hideRotatingIcon = _c.hideRotatingIcon;
    return (React.createElement(ThreeSixtyContainer, { gtmVehicleData: gtmVehicleData, height: imgHeight, hideRotatingIcon: hideRotatingIcon, iconSize: iconSize, is360EnableVisible: !is360Mode && imageLoaded, isImageLoading: !(is360Mode || imageLoaded) || isImagesLoading },
        React.createElement(Optional, { when: !is360Mode },
            React.createElement(Image, { ref: imgRef, is360Mode: is360Mode, onLoad: onImageLoaded, alt: alt === null || alt === void 0 ? void 0 : alt.value, src: currentImageUrl })),
        React.createElement(Optional, { when: is360Mode },
            React.createElement(PannellumContainer, null,
                React.createElement(Optional, { when: !panoramicImageLoaded },
                    React.createElement(ThreeSixtyAnimatedLoader, { isVisible: true })),
                React.createElement(ReactPannellum, { onPanoramaLoaded: function () {
                        setPanoramicImageLoaded(true);
                    }, config: __assign(__assign({}, defaultConfig), { preview: currentImageUrl }), style: { width: '100%', height: '100%' }, sceneId: assetColor, id: uniqueId('interior-360'), preview: currentImageUrl, imageSource: url })))));
};
export default Interior360View;
